import React from 'react'
import { Link } from 'react-router-dom'

const BannerDealSmartWatch = () => {
  return (
    <section>
    <div className="banner">
        <div className='content-banner'>
            <span className="time-line">Từ 22/07 - 31/07</span>
            <Link to='javascript:PopupHTML(4067)' className='see-info' >Xem thể lệ</Link>
        </div>
    </div>
    <div className="sub-banner">
        
    </div>
</section>
  )
}

export default BannerDealSmartWatch
